const getFirebaseErrorCode = (error) => error?.code || "unknown";

const runSecondaryTask = async (task) => {
  try {
    await task.run();
    return null;
  } catch (error) {
    return {
      operation: task.operation,
      label: task.label,
      service: task.service,
      path: task.path,
      code: getFirebaseErrorCode(error),
      retry: task,
    };
  }
};

export const saveChildProfileWithFollowUps = async ({
  uploadPhoto,
  buildProfilePatch,
  updateChild,
  secondaryTasks = [],
} = {}) => {
  let photoURL;

  try {
    photoURL = await uploadPhoto();
  } catch (error) {
    return {
      primarySaved: false,
      failure: {
        operation: "profile_photo_upload",
        label: "Profile photo upload",
        service: "Storage",
        code: getFirebaseErrorCode(error),
        error,
      },
    };
  }

  const profilePatch = buildProfilePatch(photoURL);

  try {
    await updateChild(profilePatch);
  } catch (error) {
    return {
      primarySaved: false,
      failure: {
        operation: "child_profile_update",
        label: "Profile save",
        service: "Firestore",
        code: getFirebaseErrorCode(error),
        error,
      },
    };
  }

  const warnings = (await Promise.all(
    secondaryTasks.map(runSecondaryTask)
  )).filter(Boolean);

  return {
    primarySaved: true,
    photoURL,
    profilePatch,
    warnings,
  };
};

export const retryProfileSaveFollowUps = async (warnings = []) => {
  const tasks = warnings.map((warning) => warning.retry).filter(Boolean);
  return (await Promise.all(tasks.map(runSecondaryTask))).filter(Boolean);
};
